import getFieldRenderObject from '../../../utils/newforms/render/getFieldRenderObject'
import { INDEXATION_MODE_OPTIONS, REVIEW_STATUS_OPTIONS } from './defaultSeo'

/** Form fields for compact product SEO (products; outletProducts later). */
export class CompactProductSeoForm {
  constructor() {
    this.title = {
      field: {
        fieldId: 'title',
        fieldType: 'input',
        label: 'SEO title',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.metaDescription = {
      field: {
        fieldId: 'metaDescription',
        fieldType: 'textarea',
        label: 'Meta description',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.ogTitle = {
      field: {
        fieldId: 'ogTitle',
        fieldType: 'input',
        label: 'OG title',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.ogDescription = {
      field: {
        fieldId: 'ogDescription',
        fieldType: 'textarea',
        label: 'OG description',
        required: false,
        value: '',
      },
      render: getFieldRenderObject(),
    }
    this.reviewStatus = {
      field: {
        fieldId: 'reviewStatus',
        fieldType: 'select',
        label: 'SEO review status',
        required: false,
        getOptions: REVIEW_STATUS_OPTIONS,
      },
      render: getFieldRenderObject(),
    }
    this.indexationMode = {
      field: {
        fieldId: 'indexationMode',
        fieldType: 'select',
        label: 'Indexation mode',
        required: false,
        getOptions: INDEXATION_MODE_OPTIONS,
      },
      render: getFieldRenderObject(),
    }
  }
}
